import React from "react";
import BrandFlower from "../../assets/BrandFlower";
import logo from "../../assets/images/admin-login-logo.png";
import "./AuthShell.css";

const AuthShell = ({ title, children, compact = false }) => {
  return (
    <main className="auth-page">
      <div className="auth-page__flower auth-page__flower--bottom">
        <BrandFlower petalColor="#3B5FA6" dropColor="#00ACEC" />
      </div>
      <div className="auth-page__flower auth-page__flower--top">
        <BrandFlower petalColor="#3B5FA6" dropColor="#00ACEC" />
      </div>

      <section
        className={`auth-card ${compact ? "auth-card--compact" : ""}`}
        aria-labelledby="auth-title"
      >
        <img className="auth-card__logo" src={logo} alt="7Geracoes" />
        <h1 id="auth-title" className="auth-card__title">
          {title}
        </h1>
        {children}
      </section>
    </main>
  );
};

export default AuthShell;
